/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import React,{memo, useEffect, useRef, useState} from 'react'
import { Pagination, Table ,DatePicker, Space, Select, Modal } from 'antd'
import { Button, Checkbox, Form, Input, Radio, Spin} from 'antd'
import dayjs from 'dayjs';
import {ArrowUpOutlined,ArrowDownOutlined } from '@ant-design/icons';
import { ButtonBase } from '@mui/material';
import { ExclamationCircleFilled } from '@ant-design/icons';
import jwtDecode from 'jwt-decode';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

import axios from '../apiClient'
import Alert from '../alert'
import moment from 'moment/moment';
import Loader from '../loader';

const { RangePicker } = DatePicker;
export default function ListOdds() {
    const [matches,setMatches] = useState([])
    const [oddsTotal,setOddsTotal] = useState()
    const [saveOddsLoading,setSaveOddsLoading] = useState(false)
    const [form] = Form.useForm();
    const [page,setPage] = useState(1);
    const [matchLang,setMatchLang] = useState("eng")
    const [loading,setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [date,setDate] = useState({startDate: "",endDate: ""})
    const [leagues,setLeagues] = useState([])
    const [selectedLeague,setSelectedLeague] = useState('');
    const [selectedMatchesToDelete,setSelectedMatchesToDelete] = useState([])
    const mounted = useRef(false);

    useEffect(()=>{
        const startDate = moment().subtract(1,'day').format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment().add(1,'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        setDate({startDate,endDate});
        const oddLang = JSON.parse(localStorage.getItem("oddLang"));
        if(oddLang && (oddLang == "my" || oddLang == "eng")) setMatchLang(oddLang)
  
        form.setFieldsValue({data: [{leagueId: null,matches: []}]})
        setTimeout(() => {
          form.getFieldInstance(['data',0,'leagueId'])?.focus()
        }, 100);
    },[])
    useEffect(()=>{
      if(!mounted.current){
        mounted.current = true;
      }else{
        getOdds()
      }
    },[selectedLeague,date,page])

    useEffect(()=>{
      if(!mounted.current){
        mounted.current = true;
      }else{
        getLeagues();
      }
    },[date])

    const handleCloseAlert = () => setOpenAlert(false)

    const handleOpenAlert =()=> setOpenAlert(true)

    const handleSetMatches = (matches) => setMatches(matches)

    const handlePageChange = (page) => setPage(page)
 
    const validataBeforeSave = async(values) =>{
      if(values.data.length == 0 ) {
        setErrorMsg({ info: true, msg: "Please input first" })
        setOpenAlert(true)
        return 500
      }

      try {
        await form.validateFields();
        return 200
      } catch (error) {
        setErrorMsg({ info: true, msg: "Invalid Format" })
        setOpenAlert(true)
        return 500
      }
        
    }

    const changeFormat = (values) => {
      const copy = JSON.parse(JSON.stringify(values));
      const leagues = copy.data;
      const returnData = {data: []};
      for (let z = 0; z < leagues.length; z++) { // loop the leagues
        const matches = [];
        for (let i = 0; i < leagues[z].matches.length; i++) { // loop the matches
          const match = leagues[z].matches[i];
          const hdp = match.hdp;
          const ou = match["o/u"];
          const homeTeamHasHandicap = match.homeTeamHasHandicap;
          if(!hdp || !ou || homeTeamHasHandicap == null) { // delete that index
            continue
          }else{
            const [hdpLeft,hdpSign, hdpRight] = hdp.match(/(\d+|[-+])/g)
            const [ouLeft,ouSign, ouRight] = ou.match(/(\d+|[-+])/g)
            match.bodyHandicapGoal = hdpLeft;
            match.bodyHandicapTeam = homeTeamHasHandicap ? "home_team" : "away_team";
            match.bodyOdd = hdpRight;
            match.bodyOddSign = hdpSign;
            match.ouHandicapGoal = ouLeft;
            match.ouOdd = ouRight;
            match.ouOddSign = ouSign;
            delete match.awayTeam;
            delete match.homeTeam;
            delete match.hdp;
            delete match['o/u'];
            matches.push(match);
          }
        }
        if(matches.length == 0) continue;
        returnData.data.push({leagueId:  leagues[z].leagueId,matches})
      }
      return returnData;
    }

    const handleSave = async (values) =>{
      const formatedData = changeFormat(values);
    
      const code = await validataBeforeSave(formatedData);
      if(code != 200) return;
      setSaveOddsLoading(true)
    
      const token = localStorage.getItem("token");
      const {id: ownerId} = jwtDecode(token);
      let matchesArr =[];
      formatedData.data.forEach(({matches,leagueId}) => { 
        matches.forEach(match => matchesArr.push(match) )
      });
      const odds = matchesArr.map((v)=>{
          const {matchId,bodyHandicapGoal,bodyHandicapTeam,bodyOdd,bodyOddSign,ouHandicapGoal,ouOdd,ouOddSign,periods,betType,maxLimit} = v
          return ({
          matchId: matchId,
          popular: v?.popular ? 1 : 0,
          hdp: {
              raw: [
                  bodyHandicapGoal,
                  bodyOddSign+bodyOdd
              ],
              converted: `${bodyHandicapGoal}${bodyOddSign+bodyOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          ou: {
              raw: [
                  ouHandicapGoal,
                  ouOddSign+ouOdd
              ],
              converted: `${ouHandicapGoal}${ouOddSign+ouOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          periods: periods,
          betType: betType,
          maxLimitBetAmount: maxLimit,
          createdBy: ownerId
      })})

      const params = {odds}

      const data = await axios.post(`/bet/setOddByMatchId`, params)

      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      setSaveOddsLoading(false)
    }

    const onFinish = async (values) => handleSave(values);

    const getOdds = async () => {
      setLoading(true)
      const res = await axios.get(`/bet/getBetByDate?startDate=${date.startDate}&endDate=${date.endDate}&leagueId=${selectedLeague}&current=${page}&pageSize=10`)
      await axios.get(`/bet/getMatchForoddCreate?current=${page}&pageSize=10`)
      setLoading(false)
      if(res.code ==  404){
        form.setFieldsValue({data: []})
      }
      if(res.code == 200){
        let resData = res.data.data;
        let pagination = res.data.pagination;
        setOddsTotal(pagination?.total)
        let arr =[];
        let matchArr = []
        for (let i = 0; i < resData.length; i++) {
          const {match,league} = resData[i];
          let obj={leagueId: league.id,matches: []};
  
          matchArr[i] = match.map(v=> {
            const time = v.status == "2H" ? moment(v.matchDate).add(1, 'hour').format('h:mm A') : moment(v.matchDate).format('h:mm A');
            return (
            {
             value: v.matchId,
             label: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`,
             label_mm: `${v.homeTeam.name_mm} vs ${v.awayTeam.name_mm}`,
             label_en: `${v.homeTeam.name_en} vs ${v.awayTeam.name_en}`,
             matchTime: time,
             matchStatus: v.status
            }
            )})
  
          match.forEach(m=> {
            let hdpFull;let ouFull; let hdpFirst; let ouFirst; let hdpSecond;let ouSecond;
            let homeFTHdp;let home1HHdp;let home2HHdp;
            let typeFT = 'all';let type1H = 'all';let type2H = 'all';
            let maxLimitFT = 0;let maxLimit1H = 0;let maxLimit2H = 0;
            let bodyExtraFT = 0;let bodyExtra1H = 0;let bodyExtra2H = 0;
            let ouExtraFT = 0;let ouExtra1H = 0;let ouExtra2H = 0;
            let popular = false;
            let publishFirst;
            let publishSecond ;
            let publishFull;
            let oddId;
            popular = m.popular == 1 ? true : false;
            if(m.odd){
              m.odd.forEach(o=> {
                if(o.periods == "full_time") {
                  publishFull = o.published == 1 ? true : false;
                  oddId = o.id;
                  hdpFull = o.hdp.converted;
                  ouFull = o.ou.converted;
                  homeFTHdp = o.hdp.home_team_has_hadicap;
                  typeFT = o.type;
                  maxLimitFT = o.max_limit_bet_amount;
                  bodyExtraFT = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
                  ouExtraFT = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
                  obj.matches.push({publish: publishFull,oddId,matchId: m.matchId,periods: "full_time",hdp: hdpFull,['o/u']: ouFull,homeTeamHasHandicap: homeFTHdp,popular: popular,betType: typeFT,maxLimit: maxLimitFT,bodyExtra: bodyExtraFT,ouExtra: ouExtraFT})
                }else if(o.periods == "first_time"){
                  publishFirst = o.published == 1 ? true : false;
                  oddId = o.id;
                  hdpFirst = o.hdp.converted;
                  ouFirst = o.ou.converted;
                  home1HHdp = o.hdp.home_team_has_hadicap;
                  type1H = o.type;
                  maxLimit1H = o.max_limit_bet_amount;
                  bodyExtra1H = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
                  ouExtra1H = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
                  obj.matches.push({publish: publishFirst,oddId,matchId: m.matchId,periods: "first_time",hdp: hdpFirst,['o/u']: ouFirst,homeTeamHasHandicap: home1HHdp,popular: popular,betType: type1H,maxLimit: maxLimit1H,bodyExtra: bodyExtra1H,ouExtra: ouExtra1H})
                }else{
                  publishSecond = o.published == 1 ? true : false;
                  oddId = o.id;
                  hdpSecond = o.hdp.converted;
                  ouSecond = o.ou.converted;
                  home2HHdp = o.hdp.home_team_has_hadicap;
                  type2H = o.type;
                  maxLimit2H = o.max_limit_bet_amount;
                  bodyExtra2H = `${Number(o.extra.body_extra_amount).toLocaleString()}${o.extra.body_extra_team == "equal" ? "" : o.extra.body_extra_team == "home" ? "(H)" : o.extra.body_extra_team == "away" ? "(A)" : "" }`
                  ouExtra2H = `${Number(o.extra.ou_extra_amount).toLocaleString()}${o.extra.body_extra_ou == "equal" ? "" : o.extra.body_extra_ou == "over" ? "(O)" : o.extra.body_extra_ou == "under" ? "(U)" : "" }`
                  obj.matches.push({publish: publishSecond,oddId,matchId: m.matchId,periods: "second_time",hdp: hdpSecond,['o/u']: ouSecond,homeTeamHasHandicap: home2HHdp,popular: popular,betType: type2H,maxLimit: maxLimit2H,bodyExtra: bodyExtra2H,ouExtra: ouExtra2H})
                }
              })
            }
            
          })
          arr.push(obj)
        }
  
        setMatches(matchArr)
        setTimeout(() => {
          
          form.getFieldInstance(['data',0,'matches',0,'hdp'])?.focus()
        }, 100);
      

        form.resetFields()
        form.setFieldsValue({data: arr})
        setLoading(false)
      }
      
    }

    const getLeagues = async () => {
      const data = await axios.get(`/info/getOddLeagueByDate?startDate=${date.startDate}&endDate=${date.endDate}`)
      if(data.code == 404){
        setErrorMsg({ code: data.code, msg: "No leagues found" })
        setOpenAlert(true)
      }
      if(data.code == 200){
        setErrorMsg({ code: data.code, msg: `${data.data.length} leagues found` })
        setOpenAlert(true)
        setLeagues(data.data)
      }
    }

    const handleChangeLang = async (lang) => {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve,100))
      setMatchLang(lang);
      localStorage.setItem('oddLang',JSON.stringify(lang));
      setLoading(false)
    }

    const handleDateChange = (v,dateString) => setDate({startDate: `${dateString[0]} 00:00:01`,endDate: `${dateString[1]} 23:59:59`})

    const handleDeleteOdd = async (oddId) =>{
      const res = await axios.delete(`/bet/deleteOddDataByOddId?oddId=${oddId}`);
      setErrorMsg({ code: res.code, msg: res.message })
      setOpenAlert(true);
      getOdds();
    }

    const handlePublish = async (oddId)  => {
      const res = await axios.put(`/bet/updatePublishedByOddId?oddId=${oddId}`);
      if(res.code != 200){
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
      }
    }

    const handleDelete = (oddId) => {
      let oddIds = [...selectedMatchesToDelete];
      const found = oddIds.find(o => oddId == o);
      if(found) oddIds = oddIds.filter(o => oddId != o);
      if(!found) oddIds.push(oddId);
      setSelectedMatchesToDelete(oddIds);
    }

    const apiCallToDelete = async () =>{
      if(selectedMatchesToDelete.length > 0 ){
        const oddIds = selectedMatchesToDelete.join(',')
        const res = await axios.delete(`/bet/deleteOddDataByOddId?oddId=${oddIds}`)
        if(res.code == 200){
          getOdds();
          setSelectedMatchesToDelete([]);
          return;
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
      }
    }

    return (
      <div>
        <div>
            <Space direction="vertical" size={12}>
                {/* <RangePicker 
                value={date.startDate ? [dayjs(date.startDate.split(/(\s+)/)[0], 'YYYY-MM-DD'), dayjs(date.endDate.split(/(\s+)/)[0], 'YYYY-MM-DD')] : ''}
                onChange={(v,dateString)=> handleDateChange(v,dateString)}/> */}
            </Space>
            <Select
                // defaultValue={'Ligue 2'}
                value={selectedLeague}
                style={{width: "30%" }}
                onChange={(leagueId)=> setSelectedLeague(leagueId)}
                filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
                showSearch
                options={[{value: "",label: "All"},...leagues.map(l=> {return {value: l.id,label: l.value_en}})]}
                placeholder="Select League"
          />


          <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
          <Spin spinning={loading}>
              <Header handleChangeLang={handleChangeLang} matchLang={matchLang} getOdds={getOdds} selectedOddIdsToDelete={selectedMatchesToDelete} apiCallToDelete={apiCallToDelete} />
              < Body
              onFinish={onFinish}
              form={form} 
              leagues={leagues}
              saveOddsLoading={saveOddsLoading}
              matches={matches}
              handleSave={handleSave}
              handleSetMatches={handleSetMatches}
              handleOpenAlert={handleOpenAlert}
              matchLang={matchLang}
              oddsTotal={oddsTotal}
              page={page}
              handlePageChange={handlePageChange}
              handleDeleteOdd={handleDeleteOdd}
              handlePublish={handlePublish}
              handleDelete= {handleDelete}
              />
               
            </Spin>
        </div>
      </div>
    )
}

const Header = ({handleChangeLang,matchLang,getOdds,selectedOddIdsToDelete,apiCallToDelete}) => {
  const overColor = 'red';
  const underColor = 'green';
  return (
      <div style={{display: 'flex',justifyContent: "end",alignItems: "center"}}>
       {selectedOddIdsToDelete.length > 0 && <Button style={{marginRight: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={apiCallToDelete}>
            <DeleteIcon style={{color: "red"}}/>
       </Button>}
        <div style={{ color: "black", width: "5%" }}>
          Over <ArrowUpOutlined style={{ color: overColor }} />
        </div>
        <div style={{ color: "black", width: "5%",marginRight: "1.3rem" }}>
        Under <ArrowDownOutlined style={{ color: underColor }} />
        </div>
        <Radio.Group onChange={({target})=>handleChangeLang(target.value)} value={matchLang}>
          <Radio value={'eng'}>Eng</Radio>
          <Radio value={'my'}>Mm</Radio>
        </Radio.Group>
        <Button style={{marginLeft: "2rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={getOdds}>
            <RefreshOutlinedIcon style={{color: "#673ab7"}}/>
        </Button>
      </div>
  )
}

const Body = ({onFinish,form,handleMatchChange,matches,handleSave,saveOddsLoading,matchLang,createCardMode,page,oddsTotal,handlePageChange,handleDeleteOdd,handlePublish,handleDelete}) =>{
 
  return (
    <div>
      <Form
      form={form}
      name="dynamic_form_nest_item"
      style={{
        marginTop: "2rem",
        fontFamily: "inherit",
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      autoComplete="off"
      css={css`.ant-form-item-explain-error{font-size: 0.8rem}`}
      >

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <th style={{ width: "20px",fontFamily: 'Courgette',color: "darkslategray" }}></th>
          <th style={{ width: "100px",fontFamily: 'Courgette',color: "darkslategray" }}>Time</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>HDP</th>
          <th style={{ width: "200px",fontFamily: 'Courgette',color: "darkslategray" }}>Home Team</th>
          <th style={{ width: "200px",fontFamily: 'Courgette',color: "darkslategray" }}>Away Team</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>O/U</th>
          <th style={{ width: "100px",fontFamily: 'Courgette',color: "darkslategray" }}>Max Limit</th>
          <th style={{ width: "80px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Bet Type</th>
          <th style={{ width: "70px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Publish</th>
          <th style={{ width: "90px" ,fontFamily: 'Courgette',color: "darkslategray" }}>Hdp Extra</th>
          <th style={{ width: "90px" ,fontFamily: 'Courgette',color: "darkslategray" }}>O/U Extra</th>
        </div>
      
        <div
           css={css
            `${
            `border-radius: 1rem;
             padding-top: 1rem;
             margin-top: 1rem;
             box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);`
             }
            `}
        >
          <Form.List name="data">
              {(fields, { add : leagueAdd, remove : leagueRemove }) =>
              {
                return (
              <>
              {fields.map(({ key : leagueKey, name: leagueIndex, ...restField }) =>
              {
                return  (
                    <div
                    id={`leagueIndex-${leagueIndex}`}
                    className='odd'
                    >
                        <div>
          
                            <Form.List name={[leagueIndex, 'matches']}>
                            {(fields, { add, remove }) => (
                            <>
                            {fields.map(({ key, name, ...restField }) =>
                            {
                                return  (

                                    <SelectMatchCard
                                      key={key}
                                      handleMatchChange={handleMatchChange}
                                      matches={matches}
                                      restField={restField}
                                      name={name}
                                      remove={remove}
                                      form={form}
                                      add={add}
                                      handleSave={handleSave}
                                      leagueIndex={leagueIndex}
                                      matchLang={matchLang}
                                      handleDeleteOdd={handleDeleteOdd}
                                      handlePublish={handlePublish}
                                      handleDelete = {handleDelete}
                                    />
                                )
                            }
                            )}
                            </>
                            )}
                            </Form.List>
                        </div>
                    </div>
                  )
              }
              )}

            </>
                )}
              }
          </Form.List>
        </div>
        <Pagination  className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={oddsTotal} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
        <SaveButton loading={saveOddsLoading} form={form} handleSave={handleSave}/>
      </Form>
    </div>
  )
}

const SelectMatchCard = ({matches,restField,name,form,handleSave,leagueIndex,matchLang,handleDeleteOdd,handlePublish,handleDelete}) => {
      const fieldNames = ['hdp','homeTeam','awayTeam','o/u','maxLimit','betType','publish'];
      const [modalLoading,setModalLoading] = useState(false);

      const hdpTeamColor = '#ff00c6';
      const nonHdpTeamColor = "blue";
      const overColor = 'red';
      const underColor = 'green';

      const { confirm } = Modal;
      const showConfirm = (fieldIndex) => {
        confirm({
          mask: false,
          centered: true,
          maskClosable: true, 
          title: 'Do you Want delete this odd?',
          icon: <ExclamationCircleFilled />,
          content: '',
          okText: modalLoading ? <Loader btn={true}/> : "OK",
          onOk() {
            deleteOdd(fieldIndex);
          },
        });
      };

      const handleKeyCode = async (keyName,fieldName,fieldIndex) => {

        if(keyName == 'ArrowRight' || keyName == 'Enter'){
          const index = fieldNames.findIndex((name) => name == fieldName)
          let nextFieldName = fieldNames[index + 1];
          let nextLeagueIndex = leagueIndex;
          if(index == (fieldNames.length - 1)){ // if the field is last in the match
            if(fieldIndex == (form.getFieldsValue().data[leagueIndex].matches.length - 1)){ // if the match is last in the league, go to first match of next league
              if(form.getFieldsValue().data[leagueIndex + 1]){ //check if there is first match of next league
                nextLeagueIndex = leagueIndex + 1;
                fieldIndex = 0 ;
              }else{ //return if there is no first match of next league
                return;
              }
            }else{ // if the match is not last in the league
              fieldIndex = fieldIndex + 1
            }
            nextFieldName = fieldNames[0]
          }
          form.getFieldInstance(['data',nextLeagueIndex,'matches', fieldIndex, nextFieldName]).focus()
        }

        if(keyName == 'ArrowLeft'){
          const index = fieldNames.findIndex((name) => name == fieldName)
          let nextFieldName = fieldNames[index - 1];
          let nextLeagueIndex = leagueIndex;
          if(index == 0){  //if the field is first in the match
            if(fieldIndex == 0) { // if the match is first in the league
              if(form.getFieldsValue().data[leagueIndex - 1]){ // check if there is previous league
                nextLeagueIndex = leagueIndex - 1;
                fieldIndex = form.getFieldsValue().data[leagueIndex - 1]?.matches?.length - 1 ;
              }else{ // return if there is no previous league
                return
              }
            }else{// if the match is not first in the league
              fieldIndex = fieldIndex - 1
            }
            nextFieldName = fieldNames[fieldNames.length - 1]
          }
          form.getFieldInstance(['data',nextLeagueIndex,'matches', fieldIndex, nextFieldName]).focus()
        }

        if(keyName == "Control"){
          if(fieldName == 'homeTeam' || fieldName == "awayTeam"){
            const bool = fieldName == 'homeTeam' ? true : false;
            const otherTeamName = bool ? 'awayTeam' : 'homeTeam';
            form.setFieldValue(['data',leagueIndex,'matches', fieldIndex, "homeTeamHasHandicap"],bool);
            const teamInstance = form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex, fieldName]);
            if(teamInstance){
              // teamInstance.input.style.backgroundColor  = 'rgb(44 105 103)';
              teamInstance.input.style.color  = hdpTeamColor;
              
              const otherTeamInstance = form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex, otherTeamName]);
              // otherTeamInstance.input.style.backgroundColor  = 'white';
              otherTeamInstance.input.style.color  = nonHdpTeamColor;
            }
          }
          if(fieldName == 'publish'){
            const checked = form.getFieldValue(['data',leagueIndex,'matches', fieldIndex, fieldName]) ? false : true;
            const {oddId} = form.getFieldValue(['data',leagueIndex,'matches', fieldIndex]);
            const obj = form.getFieldsValue();
            const matchId = obj.data[leagueIndex].matches[fieldIndex].matchId ;
            obj.data[leagueIndex].matches.forEach((m,matchIndex)=> {
              if(m.matchId == matchId){
                form.setFieldValue(['data',leagueIndex,'matches', matchIndex, fieldName],checked);
              }
            })
            handlePublish(oddId)
            
          }
        
        }
        if(keyName == 'CapsLock' || keyName == "s"){
          handleSave(form.getFieldsValue())
        }

        if(keyName == "Delete"){
          showConfirm(fieldIndex);
        }
      }

      const deleteOdd = async (fieldIndex) => {
        setModalLoading(true);
        const obj = {...form.getFieldsValue()}
        const newArr = obj.data[leagueIndex].matches.filter((v,index)=> index != fieldIndex)
        const match = obj.data[leagueIndex].matches.filter((v,index)=> index == fieldIndex)[0]
        const oddId = match.oddId
        obj.data[leagueIndex].matches = newArr;
        form.setFieldsValue(obj);
  
        form.getFieldInstance(['data',leagueIndex,'matches', fieldIndex - 1,fieldNames[fieldNames.length - 1] ])?.focus();
        await handleDeleteOdd(oddId);
        setModalLoading(false)

      }

      const matchIndex = name;
      const selectedMatchId = form.getFieldsValue()?.data[leagueIndex]?.matches[matchIndex]?.matchId;
      const currentCardMatch = matches[leagueIndex].find(m=> m.value == selectedMatchId);
      const periods = form.getFieldValue(['data',leagueIndex,'matches', name, 'periods']);

      let periodText ;
      if(periods == 'full_time') periodText = "FT*"
      if(periods == 'first_time') periodText = "1H*"
      if(periods == 'second_time') periodText = "2H*"
      const vsLabel = matchLang == 'my' ? currentCardMatch?.label_mm : currentCardMatch?.label_en;
      const homeTeam = vsLabel?.split(" vs ")[0]
      const awayTeam = vsLabel?.split(" vs ")[1]

      form.setFieldValue(['data',leagueIndex,'matches', name, 'homeTeam'],`${periodText} ${homeTeam}`)
      form.setFieldValue(['data',leagueIndex,'matches', name, 'awayTeam'],`${periodText} ${awayTeam}`)

      const home_team_has_hadicap = form.getFieldValue(['data',leagueIndex,'matches', name, 'homeTeamHasHandicap']);
      const bodyExtraTeam = form.getFieldValue(['data',leagueIndex,'matches', name, 'bodyExtra']).split("(")[1]?.replace(')', '');
      const ouExtraTeam = form.getFieldValue(['data',leagueIndex,'matches', name, 'ouExtra']).split("(")[1]?.replace(')', '');
    
      let bodyExtraColor;
 
      if (bodyExtraTeam == "H" && home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else if (bodyExtraTeam == "H" && !home_team_has_hadicap) {
        bodyExtraColor = nonHdpTeamColor;
      } else if (bodyExtraTeam == "A" && !home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else if (bodyExtraTeam == "A" && home_team_has_hadicap) {
        bodyExtraColor = hdpTeamColor;
      } else {
        bodyExtraColor = '';
      }

      let ouExtraColor = (ouExtraTeam == 'O') ? overColor : ( ouExtraTeam == 'U') ? underColor : 'black';


      const validateOddRange = (_, value) => {
        if (value >= 1 && value <= 100) {
          return Promise.resolve();
        }
        return Promise.reject('Odd must be between 1 and 100.');
      };
      const validateMaxLimitRange = (_, value) => {
        if(!value) return Promise.resolve();
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if (value >= 0 && value <= 10000000) {
          return Promise.resolve();
        }
        return Promise.reject("0 <=> 10,000,000");
      };

      const validateInputFormat = (_, value) => {
        if(!value) return Promise.resolve();
        const signs = ["+","-","="]
        if(/[A-Za-z]/.test(value)){
          const fieldName = _.field.split(".");
          form.setFieldValue(fieldName,value.replace(/[A-Za-z]/g, ''));
          return Promise.resolve();
        }
        if(signs.includes(value.charAt(0))){
          return Promise.reject( "Invalid Format");
        }  
        const [left, right] = value.split(/[+-]/);   
        if ((left?.length == 2 && left?.charAt(0) == '0') ||  (Number(left) > 50) || (Number(left) < 0 )  || !right || (Number(right) > 100) ) {
          return Promise.reject( "Invalid Format");
        }
        return Promise.resolve();
      };

      const onDeleteClick = () => {
        const fieldIndex = name;
        const {oddId} = form.getFieldValue(['data',leagueIndex,'matches', fieldIndex]);
        handleDelete(oddId)
      }

     return (
      <div style={{display: "flex",justifyContent: "space-around"}}>
          <Form.Item name={[name, 'delete']} 
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           style={{ color: "white", width: "20px",textAlign: 'center' }}
           valuePropName='checked'
         >
            <Checkbox onClick={onDeleteClick}/>
         </Form.Item>
          <div  style={{width: "100px",display: 'flex',flexDirection: "column"}}>
            <span style={{textAlign: "center"}}>{currentCardMatch?.matchTime}</span>
            <span style={{textAlign: "center",color: "rgb(103, 58, 183)"}}>({currentCardMatch?.matchStatus})</span>
          
          </div>
    
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'hdp']}
           style={{  width: "70px" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input style={{backgroundColor: "#d8d8d8"}} onKeyDown={(e)=> handleKeyCode(e.key,'hdp',name)}/>
         </Form.Item>

         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'homeTeam']}
           style={{ color: "white", width: "200px",}}
         >
           <Input 
           style={{
            // backgroundColor: `${home_team_has_hadicap == true && ""}`,
            backgroundColor: "#f8f6fe",
            color: `${home_team_has_hadicap == true ? hdpTeamColor : nonHdpTeamColor}`
          }}
           onKeyDown={(e)=> handleKeyCode(e.key,'homeTeam',name)} type="button" />
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'awayTeam']}
           style={{ color: "white", width: "200px"}}
         >
           <Input 
             style={{
              // backgroundColor: `${home_team_has_hadicap == false && ""}`,
              backgroundColor: "#f8f6fe",
              color: `${home_team_has_hadicap == false ? hdpTeamColor : nonHdpTeamColor }`
            }}
             onKeyDown={(e)=> handleKeyCode(e.key,'awayTeam',name)} type="button"/>
         </Form.Item>


         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'o/u']}
           style={{ color: "white", width: "70px" }}
           rules={[
            { validator: validateInputFormat }
          ]}
         >
           <Input style={{backgroundColor: "#d8d8d8"}} onKeyDown={(e)=> handleKeyCode(e.key,'o/u',name)} />
         </Form.Item>
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'maxLimit']}
           style={{ color: "white", width: "100px" }}
           rules={[
            { validator: validateMaxLimitRange }
          ]}

         >
           <Input onKeyDown={(e)=> handleKeyCode(e.key,'maxLimit',name)}/>
         </Form.Item>

         <Form.Item
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'betType']}
           style={{ color: "white", width: "80px" }}
         >
           <Select
             style={{ width: "100%", margin: 0 }}
             options={[{ value: "single", label: "single" }, { value: "mix_parlay", label: "Parlay" }, { value: "all", label: "All" }]}
             onKeyDown={(e) => handleKeyCode(e.key, 'betType', name)}
           />
         </Form.Item>
         <Form.Item name={[name, 'publish']} 
           css={css``}
           wrapperCol={{ span: 24 }}
           {...restField}
           style={{ color: "white", width: "70px",textAlign: 'center' }}
           valuePropName='checked'
         >
            <Checkbox onClick={(e)=> handleKeyCode("Control", 'publish', name)} onKeyDown={(e)=> handleKeyCode(e.key, 'publish', name)}/>
         </Form.Item>
          
         {/* <div style={{ color: "white", width: "5%" }}>
           <ArrowUpOutlined style={{color: overColor}}/>
           
         </div>
         <div style={{ color: "white", width: "5%" }}>
            <ArrowDownOutlined style={{color: underColor}}/>
         </div> */}
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'bodyExtra']}
           style={{ width: "90px" }}
         >
           <Input type='button' style={{color: bodyExtraColor,backgroundColor: "rgb(251 251 251)"}} />
         </Form.Item>
         <Form.Item
           wrapperCol={{ span: 24 }}
           {...restField}
           name={[name, 'ouExtra']}
           style={{ width: "90px" }}
         >
           <Input  type='button' style={{color: ouExtraColor,backgroundColor: "rgb(251 251 251)"}}/>
         </Form.Item>
      </div>
     )
}

const SaveButton = ({loading,form,handleSave}) =>{
  return(

   <div
       style={{
       display: "flex",
       justifyContent: "end",
       alignItems: "center",
       padding: "0.6rem 0 0 0",
       marginTop: "1rem",
       }}
   >
          
      <ButtonBase
          onClick={()=>handleSave(form.getFieldsValue())}
          component="button"
          style={{
          color: "black",
          display: "flex",
          backgroundColor: "#408E91",
          padding: "0.6rem 1.8rem",
          borderRadius: "2rem",
          justifyContent: "center",
          alignItems: "center",
          }}
      >
          {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>Save</h4>}
      </ButtonBase>
   </div>
  )
}
